// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/add.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/edit.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../assets/delete.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../assets/burger.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../../assets/sort-horizontal.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../../assets/sort-vertical.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../../assets/sort-horizontal-box.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../../assets/sort-vertical-box.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DesktopFileView{
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.DesktopFileView_fileView{
    padding-right: 12px;
}

.DesktopFileView_fileWrapper{ 
    max-height: none;
    max-width: none;
    overflow: hidden;
}

.DesktopFileView_providerHeader{
    margin-bottom: 8px;
}

.DesktopFileView_contextMenu_button{
    display: flex;
    align-items: center;
    gap: 15px;

    min-width: calc(111px + 12px * 2);
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;

    color: #000000;
    padding: 0 12px;
}

.DesktopFileView_contextMenu_button:hover{
    background-color: #F3F6FF;
}

.DesktopFileView_contextMenu_button::before{
    content: "";
    width: 13px;
    height: 13px;

    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
}

.DesktopFileView_contextMenu_button--add::before{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.DesktopFileView_contextMenu_button--edit::before{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.DesktopFileView_contextMenu_button--delete::before{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.DesktopFileView_contextMenu_button--more::before{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

/* Header container for breadcrumbs and sorting buttons */
.DesktopFileView_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 32px;
}

/* Sorting buttons container - minimalistic macOS style */
.DesktopFileView_sortButtons {
    display: flex;
    gap: 2px;
    align-items: center;
    background: rgba(255, 255, 255, 0.75);
    backdrop-filter: blur(20px);
    border-radius: 8px;
    padding: 2px;
    border: 0.5px solid rgba(0, 0, 0, 0.04);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

/* Individual sorting button - minimalistic macOS style */
.DesktopFileView_sortButton {
    width: 26px;
    height: 26px;
    background: transparent;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.15s ease;
    position: relative;
}

.DesktopFileView_sortButton:hover {
    background: rgba(0, 0, 0, 0.06);
}

.DesktopFileView_sortButton:active {
    background: rgba(0, 0, 0, 0.12);
    transform: scale(0.95);
}

/* Sorting button icons - minimalistic macOS style */
.DesktopFileView_sortIcon {
    width: 20px;
    height: 20px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    opacity: 0.7;
}

/* Horizontal sorting icon - simple dots flowing left to right */
.DesktopFileView_sortIcon--horizontal {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

/* Vertical sorting icon - simple dots flowing top to bottom */
.DesktopFileView_sortIcon--vertical {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

/* Horizontal box sorting icon - 3x3 grid with horizontal flow */
.DesktopFileView_sortIcon--horizontalBox {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

/* Vertical box sorting icon - 3x3 grid with vertical flow */
.DesktopFileView_sortIcon--verticalBox {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/desktop/DesktopFileView.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;;IAET,iCAAiC;IACjC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;;IAEjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;;IAEZ,2BAA2B;IAC3B,4BAA4B;IAC5B,wBAAwB;AAC5B;;AAEA;IACI,yDAAmD;AACvD;;AAEA;IACI,yDAAoD;AACxD;;AAEA;IACI,yDAAsD;AAC1D;;AAEA;IACI,yDAAsD;AAC1D;;AAEA,yDAAyD;AACzD;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,yDAAyD;AACzD;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,qCAAqC;IACrC,2BAA2B;IAC3B,kBAAkB;IAClB,YAAY;IACZ,uCAAuC;IACvC,yCAAyC;AAC7C;;AAEA,yDAAyD;AACzD;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,+BAA+B;IAC/B,sBAAsB;AAC1B;;AAEA,oDAAoD;AACpD;IACI,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,4BAA4B;IAC5B,2BAA2B;IAC3B,YAAY;AAChB;;AAEA,gEAAgE;AAChE;IACI,yDAA+D;AACnE;;AAEA,8DAA8D;AAC9D;IACI,yDAA6D;AACjE;;AAEA,gEAAgE;AAChE;IACI,yDAAmE;AACvE;;AAEA,4DAA4D;AAC5D;IACI,yDAAiE;AACrE","sourcesContent":[".DesktopFileView{\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n}\n\n.DesktopFileView_fileView{\n    padding-right: 12px;\n}\n\n.DesktopFileView_fileWrapper{ \n    max-height: none;\n    max-width: none;\n    overflow: hidden;\n}\n\n.DesktopFileView_providerHeader{\n    margin-bottom: 8px;\n}\n\n.DesktopFileView_contextMenu_button{\n    display: flex;\n    align-items: center;\n    gap: 15px;\n\n    min-width: calc(111px + 12px * 2);\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 20px;\n\n    color: #000000;\n    padding: 0 12px;\n}\n\n.DesktopFileView_contextMenu_button:hover{\n    background-color: #F3F6FF;\n}\n\n.DesktopFileView_contextMenu_button::before{\n    content: \"\";\n    width: 13px;\n    height: 13px;\n\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: contain;\n}\n\n.DesktopFileView_contextMenu_button--add::before{\n    background-image: url('../../../../assets/add.svg');\n}\n\n.DesktopFileView_contextMenu_button--edit::before{\n    background-image: url('../../../../assets/edit.svg');\n}\n\n.DesktopFileView_contextMenu_button--delete::before{\n    background-image: url('../../../../assets/delete.svg');\n}\n\n.DesktopFileView_contextMenu_button--more::before{\n    background-image: url('../../../../assets/burger.png');\n}\n\n/* Header container for breadcrumbs and sorting buttons */\n.DesktopFileView_header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    min-height: 32px;\n}\n\n/* Sorting buttons container - minimalistic macOS style */\n.DesktopFileView_sortButtons {\n    display: flex;\n    gap: 2px;\n    align-items: center;\n    background: rgba(255, 255, 255, 0.75);\n    backdrop-filter: blur(20px);\n    border-radius: 8px;\n    padding: 2px;\n    border: 0.5px solid rgba(0, 0, 0, 0.04);\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n/* Individual sorting button - minimalistic macOS style */\n.DesktopFileView_sortButton {\n    width: 26px;\n    height: 26px;\n    background: transparent;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.15s ease;\n    position: relative;\n}\n\n.DesktopFileView_sortButton:hover {\n    background: rgba(0, 0, 0, 0.06);\n}\n\n.DesktopFileView_sortButton:active {\n    background: rgba(0, 0, 0, 0.12);\n    transform: scale(0.95);\n}\n\n/* Sorting button icons - minimalistic macOS style */\n.DesktopFileView_sortIcon {\n    width: 20px;\n    height: 20px;\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: center;\n    opacity: 0.7;\n}\n\n/* Horizontal sorting icon - simple dots flowing left to right */\n.DesktopFileView_sortIcon--horizontal {\n    background-image: url('../../../../assets/sort-horizontal.png');\n}\n\n/* Vertical sorting icon - simple dots flowing top to bottom */\n.DesktopFileView_sortIcon--vertical {\n    background-image: url('../../../../assets/sort-vertical.png');\n}\n\n/* Horizontal box sorting icon - 3x3 grid with horizontal flow */\n.DesktopFileView_sortIcon--horizontalBox {\n    background-image: url('../../../../assets/sort-horizontal-box.png');\n}\n\n/* Vertical box sorting icon - 3x3 grid with vertical flow */\n.DesktopFileView_sortIcon--verticalBox {\n    background-image: url('../../../../assets/sort-vertical-box.png');\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
